import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { EMPTY_BROWSE_FILTERS } from '../constants/itemBrowseFilters';

/**
 * URL is the source of truth for the items browse filters.
 */

const FILTER_KEYS = Object.keys(EMPTY_BROWSE_FILTERS);

export function useUrlFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const filters = useMemo(() => {
    const out = { ...EMPTY_BROWSE_FILTERS };
    FILTER_KEYS.forEach((key) => {
      const value = searchParams.get(key);
      if (value) out[key] = value;
    });
    return out;
  }, [searchParams]);

  const setFilters = useCallback(
    (next) => {
      const merged = typeof next === 'function' ? next(filters) : { ...filters, ...next };
      const params = new URLSearchParams();
      Object.entries(merged).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
          params.set(key, String(value));
        }
      });
      setSearchParams(params, { replace: false });
    },
    [filters, setSearchParams],
  );

  const clearFilters = useCallback(() => {
    setSearchParams(new URLSearchParams(), { replace: false });
  }, [setSearchParams]);

  return { filters, setFilters, clearFilters };
}

export default useUrlFilters;
